import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Index.vue'
import Desc from '@/views/Desc.vue'
import Competition from '@/views/Competition.vue'
import Search from '@/views/Search.vue'
import Probe from '@/views/Probe.vue'
import Site from '@/views/Site.vue'
import LoginIndex from '@/views/login/Index.vue'
import Login from '@/views/login/Login.vue'
import modify from '@/views/login/modify.vue';
import show from '@/views/show.vue';
import feedback from '@/views/feedback.vue';
import statistics from '@/views/Statistics.vue';

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/',
      name: 'index',
      component: Home
    },
    {
      path: '/description',
      name: 'description',
      component: Desc
    },
    {
      path: '/competition',
      name: 'competition',
      component: Competition
    },
    {
      path: '/search',
      name: 'search',
      component: Search
    },
    {
      path: '/probe',
      name: 'probe',
      component: Probe
    },
    {
      path: '/site',
      name: 'site',
      component: Site
    },
    {
      path: '/loginindex',
      name: 'loginindex',
      component: LoginIndex
    },
    {
      path: '/modify',
      name: 'modify',
      component: modify
    },
    {
      path: '/show',
      name: 'show',
      component: show
    },
    {
      path: '/feedback',
      name: 'feedback',
      component: feedback
    },
    {
      path: '/',
      name: 'feedback',
      component: feedback
    },
    {
      path: '/statistics',
      name: 'statistics',
      component: statistics
    }

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js